// extracted by mini-css-extract-plugin
module.exports = {"Safety":"Safety_Safety__RkNzF"};